import { render, staticRenderFns } from "./SpecialClientPopup.vue?vue&type=template&id=e01225da&scoped=true"
import script from "./SpecialClientPopup.vue?vue&type=script&lang=js"
export * from "./SpecialClientPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01225da",
  null
  
)

export default component.exports